import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Select,
  Typography,
  Modal,
  Space,
  Radio,
  Form,
  message,
  Button,
  notification,
  Col,
  Input,
  Divider,
  Row,
  Upload,
  Tag,
} from "antd";
import {
  CloudUploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./BookAppointment.css";

//Actions
import {
  getPatientDropdownList,
  getPatientDropdownListReset,
} from "../../action/getPatientDropdownListAction";
import { getScheduleTimingList } from "../../action/getScheduleTimeListAction";
import {
  saveAppointment,
  saveAppointmentReset,
} from "../../action/saveAppointmentAction";
import {
  saveAppointmentReport,
  saveAppointmentReportReset,
} from "../../action/saveAppointmentReportAction";
import getcommonMaster from "../../api/getCommonMasterApi";

//Style
import {
  RadioButton,
  RightCard,
  SelectBox,
  UploadBox,
  XCalendar,
  XSubmit,
} from "./BookAppointmentStyle";
import { PageContainer } from "../../component/Xcomponent";
import {
  getS3SingedUrl,
  timeSlotFormat,
  validateImagePdfFile,
} from "../../utils";
import HeaderContext from "../../context/HeaderContext";
//Constants
const { Option } = Select;
const { Title } = Typography;

const BookAppointment = (props) => {
  const {
    getScheduleTimingList,
    getScheduleTimingListState,
    saveAppointment,
    saveAppointmentState,
    saveAppointmentReset,
    getPatientDropdownList,
    getPatientDropdownListState,
    getPatientDropdownListReset,
    getDoctorDetailState,
    saveAppointmentReport,
    saveAppointmentReportReset,
    saveAppointmentReportState,
  } = props;

  const [value, setValue] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [TimeSlots, setTimeSlots] = useState([]);
  const [visiblePatientForm, setVisiblePatientForm] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [currentFileType, setCurrentFileType] = useState(""); // Current file format
  const [form] = Form.useForm();
  const [feetype, setfeetype] = useState();
  const [Price, setPrice] = useState();
  const [CommondataPrice, setCommondataPrice] = useState([]);
  const [feesz, setfeesz] = useState();
  const [useTierFee , setUseTierFee] = useState(false);
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [consultationFees, setconsultationFees] = useState();
  const [firstConsultationFees, setFirstConsultationFees] = useState();
  const [followUpFees, setFollowUpFees] = useState();

  // const [savePaymentDataState, setSavePaymentDataState] = useState("");

  // let self_fee = JSON.parse(localStorage.getItem("self_fee"));
  // let couple_fee = JSON.parse(localStorage.getItem("couple_fee"));
  // let family_fee = JSON.parse(localStorage.getItem("family_fee"));

  const [formData, setFormData] = useState({
    patient_id: "",
    date: new Date(),
    time_slot_start: "",
    time_slot_end: "",
    some_one_else: false,
    file_path: [],
    status: "pending",
    fee_type: "",
    amount: feesz,
  });
  const {setTitle} = useContext(HeaderContext);
  setTitle("Book Consultation for Patient");

  const plainOptions = [
    "Therapy for me(Indivisual)",
    "Therapy for us(Couples)",
    "Therapy for all(Family)",
  ];

  //Callbacks

  useEffect(()=>{
    if(getDoctorDetailState.apiState == "success"){
      
      if(getDoctorDetailState.data.type=="GC")
      {
        setUseTierFee(true)
        setfeesz(getDoctorDetailState.data.tier_1_fee)
        setPrice("Consultation price: INR " + getDoctorDetailState.data.tier_1_fee + "/-")
        setFormData({...formData,['amount']:getDoctorDetailState.data.tier_1_fee})
        setFirstConsultationFees(
          getDoctorDetailState.data.tier_1_fee
        );
        setFollowUpFees(getDoctorDetailState.data.tier_2_fee);
        setconsultationFees(
          "Consultation price: INR " +
            getDoctorDetailState.data.tier_1_fee +
            "/-"
        );
      }
      else if(getDoctorDetailState.data.type=="MHC")
      {
        if((!getDoctorDetailState.data.self_fee || getDoctorDetailState.data.self_fee==null)&&(!getDoctorDetailState.data.couple_fee || getDoctorDetailState.data.couple_fee==null)&&(!getDoctorDetailState.data.family_fee || getDoctorDetailState.data.family_fee==null))
        { 
          setUseTierFee(true)
          setfeesz(getDoctorDetailState.data.tier_1_fee)
          setPrice("Consultation price: INR " + getDoctorDetailState.data.tier_1_fee + "/-")
          setFormData({...formData,['amount']:getDoctorDetailState.data.tier_1_fee})
          setFirstConsultationFees(
            getDoctorDetailState.data.tier_1_fee
          );
          setFollowUpFees(getDoctorDetailState.data.tier_2_fee);
          setconsultationFees(
            "Consultation price: INR " +
              getDoctorDetailState.data.tier_1_fee +
              "/-"
          );
        }
      }
      
    }
  }, [getDoctorDetailState]);

  useEffect(() => {
    return () => {
      getPatientDropdownListReset();
    };
  }, []);

  useEffect(() => {
    if (getScheduleTimingListState.apiState === "success") {
      console.log(
        "getScheduleTimingListState.list.schedule_timing_slot",
        getScheduleTimingListState
      );
      const timings = [];
      if (getScheduleTimingListState?.list?.schedule_timing_slot?.length > 0) {
        //when there are basic Slots
        const x =
          getScheduleTimingListState?.list?.schedule_timing_slot[0]?.time_slots.map(
            (T) => {
              timings.push(T);
            }
          );
      }
      setTimeSlots(timings);
      setShowTimeSlots(true);
    }
    if (getScheduleTimingListState.apiState === "error") {
      notification["error"]({
        message: getScheduleTimingListState.message,
        placement: "topRight",
      });
    }
  }, [getScheduleTimingListState]);

  useEffect(() => {
    if (saveAppointmentState.apiState === "success") {
      if (fileList.length > 0) {
        let file_path_url = [];
      const promises = fileList.map(async (file) => {
        let filename = uuidv4();
        let imageValidationRes = validateImagePdfFile(file);
        if (imageValidationRes.status) {
          let data = {
            "file_path":`${filename}.${imageValidationRes.ext}`,
          }
          file_path_url.push(data);
          // formData.file_path = `${filename}.${imageValidationRes.ext}`
        } else {
          alert("Select file type JPG, PNG or PDF file.");
          return;
        }
      });
      const reports ={
        "date": new Date(),
        "time_slot_start": formData.time_slot_start,
        "time_slot_end": formData.time_slot_end,
        "some_one_else": formData.some_one_else,
        "status": formData.status,
        "fee_type": formData.fee_type,
        "amount": formData.amount,
        "patient_id":formData.patient_id,
        "reports":file_path_url,
        "book_appointment_id":saveAppointmentState.data._id,
        "report_of":"patient",
      }
        saveAppointmentReport(reports);
        // saveAppointmentReport({
        //   ...formData,
        //   ["report_of"]: "patient",
        //   ["book_appointment_id"]: saveAppointmentState.data._id,
        // });
      } else {

        setShowTimeSlots(false);
        setTimeSlots([]);
        setFileList([]);
        setIsModalVisible(false);
        let selectedDate = new Date(formData.date);
        form.resetFields();
        form.setFieldsValue({
          Date: selectedDate,
        })
        getData(selectedDate);
        // setFormData(initialFormData)
        notification["success"]({
          message: saveAppointmentState.message,
          placement: "topRight",
        });
        saveAppointmentReportReset();
        saveAppointmentReset();
      }
      setPrice("Consultation price: INR " + firstConsultationFees + "/-")
    }
    if (saveAppointmentState.apiState === "error") {
      notification["error"]({
        message: saveAppointmentState.message,
        placement: "topRight",
      });
    }
  }, [saveAppointmentState]);

  useEffect(() => {
    if (saveAppointmentReportState.apiState === "success") {
      setTimeSlots([]);
      setFileList([]);
      setIsModalVisible(false);
      form.resetFields();
      // setFormData(initialFormData)
      notification["success"]({
        message: saveAppointmentState.message,
        placement: "topRight",
      });
      saveAppointmentReportReset();
      saveAppointmentReset();
    }
    if (saveAppointmentReportState.apiState === "error") {
      saveAppointmentReportReset();
      notification["error"]({
        message: saveAppointmentReportState.message,
        placement: "topRight",
      });
    }
  }, [saveAppointmentReportState]);

  useEffect(() => {
    // data.push(getcommonMaster());
    form.setFieldsValue({ Date: new Date() });
    getData(new Date());
    getcommonMaster().then((res)=>{
      let data = res;
      if (data.length > 0) {
        let cdata = data[0].data.data.result.filter((person) =>
          person.slug.toLowerCase().includes("consultation-type")
        );
        if (cdata.length > 0) {
          setCommondataPrice(cdata[0].common_master_detail);
        }
      }
    });
  }, []);

  //Functions
  const onChangefee = (checkedValues) => {
    // const tempData = { ...formData };
    // console.log("checkedValues => ",checkedValues.target.value);
    setfeetype(checkedValues.target.value);
    setFormData()

    if (checkedValues.target.value === "self_fee") {
      setPrice(
        "Consultation price: INR " + getDoctorDetailState.data.self_fee + "/-"
      );
      setfeesz(getDoctorDetailState.data.self_fee);
      setFormData({
        ...formData,
        ["amount"]: getDoctorDetailState.data.self_fee,
      });
      // tempData.amount = getDoctorDetailState.data.self_fee;
    }
    if (checkedValues.target.value === "couple_fee") {
      setPrice(
        "Consultation price: INR " + getDoctorDetailState.data.couple_fee + "/-"
      );
      setfeesz(getDoctorDetailState.data.couple_fee);
      setFormData({
        ...formData,
        ["amount"]: getDoctorDetailState.data.couple_fee,
      });
      // tempData.amount = getDoctorDetailState.data.couple_fee;
    }
    if (checkedValues.target.value === "family_fee") {
      setPrice(
        "Consultation price: INR " + getDoctorDetailState.data.family_fee + "/-"
      );
      setfeesz(getDoctorDetailState.data.family_fee);
      setFormData({
        ...formData,
        ["amount"]: getDoctorDetailState.data.family_fee,
      });
      // tempData.amount = family_fee;
    }
    // tempData.fee_type = feetype;

    // setFormData(tempData);

    setFormData({ ...formData, ["fee_type"]: checkedValues.target.value });
  };
  
  const getData = (value) => {
    setSelectedDate(value);
    setShowTimeSlots(false);
    value = moment(value);
    let sendDay = "";
    const dayNum = value.weekday();
    const date = value.format("YYYY-MM-DD");
    if (dayNum === 1) {
      sendDay = "Monday";
    }
    if (dayNum === 2) {
      sendDay = "Tuesday";
    }
    if (dayNum === 3) {
      sendDay = "Wednesday";
    }
    if (dayNum === 4) {
      sendDay = "Thursday";
    }
    if (dayNum === 5) {
      sendDay = "Friday";
    }
    if (dayNum === 6) {
      sendDay = "Saturday";
    }
    if (dayNum === 0) {
      sendDay = "Sunday";
    }
    setFormData({
      ...formData,
      ["date"]: date,
      ["time_slot_start"]: "",
      ["time_slot_end"]: "",
    });
    form.setFieldsValue({ time_slot_start: "" });
    const params = {
      day: sendDay,
      date: date,
    };
    getScheduleTimingList(params);
    setVisiblePatientForm(false);
  };
  
  const GetTimeSlots = (props) => {
    if (props.slots.length === 0 && formData.date) {
      return (
        <Radio.Button optionType="button" className="bookAppoitSorryBtn">
          Sorry, No Time Slots available. Check another date
        </Radio.Button>
      );
    } else {
      return (
        <>
          {TimeSlots.map(
            (item, i) =>
              item.is_future_slot && (
                <RadioButton
                  disabled={item.booked}
                  value={i}
                  onClick={() => getItem(item, i)}
                >
                  {timeSlotFormat(item.start_time)} -{" "}
                  {timeSlotFormat(item.end_time)}
                </RadioButton>
              )
          )}
        </>
      );
    }
  };

  //Add patient form
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select style={{ width: 100 }}>
        <Option value="+91">+91</Option>
        <Option value="+41">+41</Option>
      </Select>
    </Form.Item>
  );

  const onFinishPatientForm = () => {
    //api called for patient
    setVisiblePatientForm(false);
  };

  const PatientForm = () => {
    return (
      <Form name="basic" layout="vertical" onFinish={onFinishPatientForm}>
        <Form.Item
          label="Full Name"
          name="Full_Name"
          rules={[{ required: true, message: "Please input your Full name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="PhNum"
          rules={[{ required: true, message: "Please input your Number!" }]}
        >
          <Input addonBefore={prefixSelector} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Email"
          name="Email"
          rules={[
            {
              required: true,
              message: "Please input your Email!",
              type: "email",
            },
          ]}
        >
          <Input />
        </Form.Item>

        {getDoctorDetailState.data.type === "MHC" && (
          <Form.Item
            name="Therapy"
            rules={[{ required: true, message: "Please select your choice!" }]}
          >
            <Radio.Group options={plainOptions} />
          </Form.Item>
        )}

        <Form.Item wrapperCol={{ offset: 19, span: 16 }}>
          <Space>
            <Button
              className="borderNonPrimary"
              type="default"
              size="large"
              onClick={() => setVisiblePatientForm(false)}
            >
              Cancel
            </Button>
            <Button className="borderPrimary" type="primary" htmlType="submit" size="large">
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    );
  };

  const getItem = (item, i) => {
    setFormData({
      ...formData,
      ["time_slot_start"]: item.start_time,
      ["time_slot_end"]: item.end_time,
    });
  };

  const Submit = async () => {
    if (fileList.length > 0) {
      let file_path_url = [];
      const promises = fileList.map(async (file) => {
        let filename = uuidv4();
        let imageValidationRes = validateImagePdfFile(file);
        if (imageValidationRes.status) {
          let s3UrlResImage = await getS3SingedUrl(
            filename,
            imageValidationRes.ext,
            file,
            "patient-report"
          );
          await axios.put(s3UrlResImage.url, file);
          file_path_url.push(`${filename}.${imageValidationRes.ext}`);
          // formData.file_path = `${filename}.${imageValidationRes.ext}`
        } else {
          alert("Select file type JPG, PNG or PDF file.");
          return;
        }
      });

      await Promise.all(promises);
      setFormData({ ...formData, ["file_path"]: file_path_url });
      saveAppointment(formData);
      console.log("formData formData", formData);
    } else {
      saveAppointment(formData);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChangeSelect = (name, value) => {
    if (name === "patient_id") {
      const selectedPatient = getPatientDropdownListState.list.find(
        (obj) => obj._id === value
      );
      if (selectedPatient) {
        const fullName = `${selectedPatient.name.firstName} ${selectedPatient.name.lastName}`;
        setPatientName(fullName);
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const onPanelChange = (value, mode) => {};

  const onFinish = () => {
    setIsModalVisible(true);
  };

  const PatientAdd = () => {
    setVisiblePatientForm(true);
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const onPreview = async (file) => {
    let extension = file.name.substr(file.name.lastIndexOf(".") + 1);
    let src = file.preview;

    if (extension === "jpg" || extension === "jpeg" || extension === "png") {
      setCurrentFileType("image");
      setPreviewImage(src);
      setPreviewVisible(true);
    } else {
      setCurrentFileType("pdf");
      setPreviewImage(src);
      setPreviewVisible(true);
    }
  };

  const handleCancelPreview = () => {
    setPreviewVisible(false);
  };
  const fileUploadAction = async (file) => {
    if (
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg" ||
      file.type === "application/pdf"
    ) {
      let fileData = fileList;
      fileData.push(file);
      setFileList(fileData);
      let url = await getBase64(file);
      file.url = url;
      file.preview = url;
      return file.url;
    }
  };

  function formatDateToLong(dateStr) {
    const date = new Date(dateStr);

    function getDayWithSuffix(day) {
      if (day >= 11 && day <= 13) {
        return day + "th";
      }
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${getDayWithSuffix(day)} ${month}, ${year}`;
  }

  const handleConsultationType = (val) => {
    // setfeetype(val);
    // setFormData({ ...formData, ["fee_type"]: val });
    if (val === "first") {
      setFormData({...formData,['amount']:firstConsultationFees,["fee_type"]: val})
      setPrice("Consultation price: INR " + firstConsultationFees + "/-")
      setfeesz(firstConsultationFees);
    } else if (val === "follow_up") {
      setFormData({...formData,['amount']:followUpFees,["fee_type"]: val})
      setPrice("Consultation price: INR " + followUpFees + "/-")
      setfeesz(followUpFees);
    }
  };

  return (
    <>
    { getDoctorDetailState.apiState=="success" && getDoctorDetailState.data.is_dcp_activated=="Yes" ? 
      <PageContainer>
      {/* {visiblePatientForm ?
                    <PatientForm />
                    : */}
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={20}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="Date"
                colon={false}
                requiredMark="optional"
                rules={[{ required: true, message: "Select a date and slot" }]}
              >
                <DatePicker
                  style={{ width: "100%"}}
                  initialDate={new Date()}
                  onChange={(date) => getData(date)}
                  minDate={new Date()}
                  selected={selectedDate}
                  showDisabledMonthNavigation
                  inline
                />
              </Form.Item>
              {
                showTimeSlots && 
                <Row gutter={20}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item
                      name="time_slot_start"
                      rules={[{ required: true, message: "Please select time slot" }]}
                    >
                      <Radio.Group
                        name="time_slot_start"
                        size="large"
                        className="bookAppoitTimeSlot"
                      >
                        <GetTimeSlots slots={TimeSlots} />
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row> 
              }
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginBottom:"20px"}}>
                <RightCard>
                  <Form.Item
                    style={{padding:"0 24px"}}
                    name="patient_id"
                    rules={[{ required: true, message: "Please select patient" }]}
                  >
                    <SelectBox
                      name="patient_id"
                      placeholder="Select patient name"
                      allowClear
                      onChange={(v) => handleChangeSelect("patient_id", v)}
                      size="large"
                      showSearch
                      onSearch={_.debounce(function (value) {
                        getPatientDropdownList({
                          name: value,
                        });
                      }, 500)}
                      filterOption={false}
                    >
                      {getPatientDropdownListState.list.map((obj) => (
                        <SelectBox.Option value={obj._id} key={obj._id}>
                          {obj.name.firstName} {obj.name.lastName}
                        </SelectBox.Option>
                      ))}
                    </SelectBox>
                  </Form.Item>

                  {/* add new feild */}
                              <Form.Item
                                     style={{padding:"0 24px"}}
                                    name="fee_type"
                                    // defaultValue={form.getFieldValue("apptType")}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please select counseling type",
                                      },
                                    ]}
                                  >
                                    <Select
                                      className="cbTextBorder"
                                      placeholder="Select Counseling Type"
                                      size="large"
                                      onChange={(value) => {
                                        handleConsultationType(value);
                                      }}
                                    >
                                      <Option value="first">
                                        First Consultation
                                      </Option>
                                      <Option value="follow_up">
                                        Follow Up Consultation
                                      </Option>
                                    </Select>
                                  </Form.Item>

                  {getDoctorDetailState.apiState == "success" && !useTierFee ? (
                    <>
                      <Title style={{ marginBottom: "15px", padding:"0 25px"}} level={5}>
                        What type of counselling are you looking for?
                      </Title>
                      <Form.Item
                        style={{margin:0}}
                        rules={[
                          { required: true, message: "Please select an option!" },
                        ]}
                      >
                        <Radio.Group
                          name="fee_type"
                          style={{ width: "100%",padding: "0 25px" }}
                          rules={[
                            {
                              required: true,
                              message: "Please select an option!",
                            },
                          ]}
                          onChange={onChangefee}
                        >
                          {getDoctorDetailState.data.self_fee > 0 && (
                            <Radio
                              style={{ width: "100%", height: "50px" }}
                              value="self_fee"
                            >
                              Therapy for me (Individual)
                            </Radio>
                          )}
                          {getDoctorDetailState.data.couple_fee > 0 && (
                            <Radio
                              style={{ width: "100%", height: "50px" }}
                              value="couple_fee"
                            >
                              Therapy for us (Couples)
                            </Radio>
                          )}
                          {getDoctorDetailState.data.family_fee > 0 && (
                            <Radio
                              style={{ width: "100%", height: "50px" }}
                              value="family_fee"
                            >
                              Therapy for us (Family)
                            </Radio>
                          )}
                          {/* {CommondataPrice.map((price) => {
                            return (
                              <Radio
                                style={{ width: "100%", height: "50px" }}
                                value={price.value}
                              >
                                {price.value === "Self"
                                  ? "Therapy for me(Individual)"
                                  : price.value === "Couple"
                                  ? "Therapy for us(Couples)"
                                  : price.value === "Family"
                                  ? "Therapy for all(Family)"
                                  : ""}
                              </Radio>
                            );
                          })} */}
                        </Radio.Group>
                        
                        <Input
                          // style={{ height: "100px",color:"#883DA9",fontWeight:"500" ,textAlign:"center" }}
                          className="cbTextBorder cbTextBackground mb-0 pb-0"
                          readOnly
                          value={Price}
                          size="large"
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item style={{margin:"0"}}>
                      
                      <Input
                        className="cbTextBorder cbTextBackground mb-0 pb-0 "
                        readOnly
                        value={Price}
                        size="large"
                      />
                    </Form.Item>
                  )}
                </RightCard>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    name="report"
                    // label="Upload Report (Img/Pdf)"
                    // rules={[{ required: true, message: "Report is required" }]}
                  >
                    <UploadBox
                      listType="picture-card"
                      name="report"
                      onPreview={onPreview}
                      action={(file) => fileUploadAction(file)}
                      className="avatar-uploader"
                      beforeUpload={(file) => {
                        if (
                          file.type === "image/png" ||
                          file.type === "image/jpg" ||
                          file.type === "image/jpeg" ||
                          file.type === "application/pdf"
                        ) {
                          const maxSize = 10 * 1024 * 1024;
                          if (file.size > maxSize) {
                            message.error('File size exceeds 10MB limit.');
                            return Upload.LIST_IGNORE;
                          }              
                        } else {
                          message.error(`Select png, jpg or pdf file only.`);
                        }
                        return file.type === "image/png" ||
                          file.type === "image/jpg" ||
                          file.type === "image/jpeg" ||
                          file.type === "application/pdf"
                          ? true
                          : Upload.LIST_IGNORE;
                      }}
                      onRemove={(file) => {
                        const index = fileList.indexOf(file);
                        const newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        setFileList(newFileList);
                      }}
                      allowedFileTypes={["image/jpg", "image/jpeg"]}
                      fileTypeValidationMessage={
                        "Only JPG & JPEG file types allowed!"
                      }
                    >
                      <div style={{ display: "flex", flexDirection: "column", alignItems:"center" }}>
                        <CloudUploadOutlined
                          style={{ fontSize: 70, color: "#883DA9" }}
                        />
                        <span style={{ color: "#b1b1b1",fontWeight:"600" }}>
                          Upload Report (Img/PDF)
                        </span>
                      </div>
                    </UploadBox>
                  </Form.Item>
                  <Modal
                    visible={previewVisible}
                    footer={null}
                    onCancel={handleCancelPreview}
                  >
                    {currentFileType === "pdf" ? (
                      <iframe
                        title="PDF"
                        className="scrolling"
                        scrolling="no"
                        frameBorder="0"
                        id="press"
                        src={previewImage}
                        width="100%"
                        height={630}
                      />
                    ) : (
                      <img
                        alt="example"
                        style={{ width: "100%" }}
                        src={previewImage}
                      />
                    )}
                  </Modal>
                </Col>
                </Row>
            </Col>
          </Row>
          {/* {
            showTimeSlots && 
            <Row gutter={20}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name="time_slot_start"
                  rules={[{ required: true, message: "Please select time slot" }]}
                >
                  <Radio.Group
                    name="time_slot_start"
                    size="large"
                    className="bookAppoitTimeSlot"
                  >
                    <GetTimeSlots slots={TimeSlots} />
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row> 
          } */}
          <Row gutter={20}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-5">
              <XSubmit
                size="large"
                className="borderPrimary"
                disabled={visiblePatientForm}
                type="primary"
                htmlType="submit"
              >
                {!visiblePatientForm ? "Book Appointment" : null}
              </XSubmit>
            </Col>
          </Row>
          <Modal
            title={
              <span className="d-flex align-items-center">
                <svg width="25" height="30" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight:"20px"}}>
                  <g clip-path="url(#clip0_5121_1726)">
                  <path d="M0 12V10.5C0 6.3645 3.3645 3 7.5 3H9V1.5C9 0.672 9.6705 0 10.5 0C11.3295 0 12 0.672 12 1.5V3H24V1.5C24 0.672 24.6705 0 25.5 0C26.3295 0 27 0.672 27 1.5V3H28.5C32.6355 3 36 6.3645 36 10.5V12H0ZM36 15V28.5C36 32.6355 32.6355 36 28.5 36H7.5C3.3645 36 0 32.6355 0 28.5V15H36ZM18 28.5C18 27.672 17.3295 27 16.5 27H9C8.1705 27 7.5 27.672 7.5 28.5C7.5 29.328 8.1705 30 9 30H16.5C17.3295 30 18 29.328 18 28.5ZM28.5 22.5C28.5 21.672 27.8295 21 27 21H9C8.1705 21 7.5 21.672 7.5 22.5C7.5 23.328 8.1705 24 9 24H27C27.8295 24 28.5 23.328 28.5 22.5Z" fill="#883DA9"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_5121_1726">
                  <rect width="36" height="36" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>Book Appointment
              </span>
            }
            style={{ top: 20 }}
            visible={isModalVisible}
            okText="Confirm"
            // onOk={Submit}
            onCancel={handleCancel}
            footer={[
              <Button className="borderNonPrimary" key="back" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button
                className="borderPrimary"
                key="submit"
                type="primary"
                loading={saveAppointmentState.apiState === "loading"}
                onClick={Submit}
              >
                Submit
              </Button>,
            ]}
          >
            <p style={{fontSize:"18px", fontWeight:"400",color:"#6F6C90"}}>
              Do you want to book appointment with Patient {patientName} from{" "}
              {timeSlotFormat(formData.time_slot_start)} to{" "}
              {timeSlotFormat(formData.time_slot_end)} on{" "}
              {formatDateToLong(formData.date)}?
            </p>
          </Modal>
        </Form>

          {/* } */}
        </PageContainer>
        :
        <PageContainer>
          <h6>Access Not Authorized</h6>
        </PageContainer>
      }
    </>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getPatientDropdownListState: state.getPatientDropdownList,
  saveAppointmentState: state.saveAppointment,
  getScheduleTimingListState: state.getScheduleTimingList,
  getDoctorDetailState: state.getDoctorDetail,
  saveAppointmentReportState: state.saveAppointmentReport,
});

const mapDispatchToProps = (dispatch) => ({
  getPatientDropdownList: (params) => dispatch(getPatientDropdownList(params)),
  getPatientDropdownListReset: () => dispatch(getPatientDropdownListReset()),
  saveAppointment: (params) => dispatch(saveAppointment(params)),
  saveAppointmentReset: () => dispatch(saveAppointmentReset()),
  getScheduleTimingList: (params) => dispatch(getScheduleTimingList(params)),
  saveAppointmentReport: (params) => dispatch(saveAppointmentReport(params)),
  saveAppointmentReportReset: () => dispatch(saveAppointmentReportReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookAppointment);
